import axios from 'axios';
import router from '@/router';
import {
	utilityService
} from '@/services/utilityService.js';
import {
	authTokenService
} from '@/services/authTokenService.js';

export const authService = {
	login,
	logout,
	resetPassword,
	changePassword,
	forgotPassword,
	isAuthenticated,
	signin,
	getUserRoles,
	getUserAccesses,
	createAccountUser,
	updateAccountUser,
	getAccountUser,
	getAllAccountUsers
};

/**
 * Logs the user in.
 * @param {string} userName
 * @param {*} password
 * @returns the promise
 */
function login (userName, password) {
	// Clear any access_token values that may be floating around in local storage
	authTokenService.clearToken();
	authTokenService.clearSessionState();
	
	return axios.post(utilityService.getApiUrl('ui/account/login'),
			// Second parameter is the data/body
			{
				username: userName,
				password: password
			},
			// Third parameter is the configuration object
			{
				headers: utilityService.getHeaders()
			}
		)
		.then(function (response) {
			authTokenService.saveToken(response.data.token);
		})
		.catch(function (e) {
			console.error(e);
			throw e;
		});
}

function changePassword (userName, oldPassword, newPassword, confirmPassword) {
	// Clear any access_token values that may be floating around in local storage

	return axios.put(utilityService.getApiUrl('user/password'),
			// Second parameter is the data/body
			{
				UserId: userName,
				OldPassword: oldPassword,
				NewPassword: newPassword,
				ConfirmPassword: confirmPassword
			},
			// Third parameter is the configuration object
			{
				headers: utilityService.getHeaders()
			}
		)
		.then(function (response) {
			// authService.login(userName, newPassword);
		})
		.catch(function (e) {
			console.error(e);
			throw e;
		});
}

function resetPassword (newPassword, confirmPassword) {
	// Clear any access_token values that may be floating around in local storage

	return axios.put(utilityService.getApiUrl('user/resetpassword'),
			// Second parameter is the data/body
			{
				NewPassword: newPassword,
				ConfirmPassword: confirmPassword
			},
			// Third parameter is the configuration object
			{
				headers: utilityService.getHeaders()
			}
		)
		.then(function (response) {
			// authService.login(userName, newPassword);
		})
		.catch(function (e) {
			console.error(e);
			throw e;
		});
}

function forgotPassword (userNameOrEmail) {
	// Clear any access_token values that may be floating around in local storage

	return axios.post(utilityService.getApiUrl('user/forgotpassword'),
			// Second parameter is the data/body
			{
				UserNameOrEmail: userNameOrEmail
			},
			// Third parameter is the configuration object
			{
				headers: utilityService.getHeaders()
			}
		)
		.then(function (response) {
			// authService.login(userName, newPassword);
		})
		.catch(function (e) {
			console.error(e);
			throw e;
		});
}

function logout (timedOut) {
	authTokenService.clearToken();
	authTokenService.clearSessionState();
	router.push({ path: 'login', query: { timeOut: timedOut } })
}

/**
 * Returns true if the user has a token stored in local storage.
 */
function isAuthenticated () {
	return authTokenService.getToken() != null;
}

// #region account
function signin (username, password) {
	return axios.post(utilityService.buildFullyQualifiedUrl(`account/login`),
		// Second parameter is the data/body
		{
			username: username,
			password: password
		},
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getUserRoles () {
	return axios.get(utilityService.buildFullyQualifiedUrl(`account/roles?type=FIELD`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getUserAccesses () {
	return axios.get(utilityService.buildFullyQualifiedUrl(`account/roles?type=ACCESS`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function createAccountUser (criteria) {
	return axios.post(utilityService.buildFullyQualifiedUrl(`account/user?studyCode=${criteria.study}`),
		// Second parameter is the data/body
		{
			data: criteria.user
		},
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function updateAccountUser (criteria) {
	return axios.put(utilityService.buildFullyQualifiedUrl(`account/user/update?studyCode=${criteria.study}`),
		// Second parameter is the data/body
		{
			data: criteria.user
		},
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getAccountUser (criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`account/user?studyCode=$study$&userId=${criteria.staffid}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getAllAccountUsers (criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`account/users?studyCode=${criteria.study}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}
// #endregion account
